import { Download } from "lucide-react"
import { FC } from "react"

type ExportButtonColorVariant = 'blue' | 'green' | 'red' | 'white'

type ExportButtonProps = {
  title: string
  color: ExportButtonColorVariant,
  onClick?: () => void
}

const getExportButtonColorVariant = (variant: ExportButtonColorVariant) => {
  switch(variant) {
    case 'red':
      return 'bg-red-600 hover:bg-red-700 text-white'
    case 'green':
      return 'bg-green-600 hover:bg-green-700 text-white'
    case 'white':
      return 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
    default:
      return 'bg-primary-600 hover:bg-primary-700 text-white'
  }
}

export const ExportButton: FC<ExportButtonProps> = ({ title, color, onClick }) => {
  const handleClick = () => {
    if (onClick) onClick()
  }

  const colorVariant = getExportButtonColorVariant(color)

  return (
    <button onClick={handleClick} className={`flex items-center gap-2 px-6 py-3 ${colorVariant} rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors`}>
      <Download className="w-5 h-5" />
      <span>{title}</span>
    </button>
  )
}

export default ExportButton
